const messages = {
  de: {
    bannerTitle: 'Cookie-Einstellungen',
    bannerText: 'Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. Einige Cookies sind für den Betrieb der Website erforderlich, während andere uns helfen, die Nutzung zu analysieren und unser Angebot zu verbessern.',
    acceptAll: 'Alle akzeptieren',
    requiredOnly: 'Nur erforderliche',
    details: 'Details',
    saveSelection: 'Auswahl speichern',
    close: 'Schliessen',
    alwaysActive: 'Immer aktiv',
    requiredCategory: 'Erforderlich',
    requiredDescription: 'Diese Cookies sind für den Betrieb der Website notwendig und können nicht deaktiviert werden. Sie ermöglichen grundlegende Funktionen wie Seitennavigation und Spam-Schutz.',
    statisticsCategory: 'Statistik / Marketing',
    statisticsDescription: 'Diese Cookies helfen uns, die Nutzung unserer Website zu verstehen und unser Angebot zu verbessern. Sie ermöglichen die Erfassung anonymisierter Besuchsdaten.',
    cookieName: 'Cookie',
    cookieProvider: 'Anbieter',
    cookiePurpose: 'Zweck',
    cookieDuration: 'Dauer',
    session: 'Sitzung',
    minutes30: '30 Minuten',
    hours24: '24 Stunden',
    days365: '1 Jahr',
    years2: '2 Jahre',
    purposeSession: 'Session-Verwaltung',
    purposeTurnstile: 'Spam-Schutz',
    purposeConsent: 'Speichert Cookie-Einstellungen',
    purposeGa: 'Besucher-Identifikation für Webanalyse',
    purposeGid: 'Temporäre Besucher-Identifikation',
    purposeHotjarUser: 'Besucher-Identifikation für Heatmaps',
    purposeHotjarSession: 'Session-Tracking für Heatmaps',
  },
  fr: {
    bannerTitle: 'Paramètres des cookies',
    bannerText: 'Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur notre site. Certains cookies sont nécessaires au fonctionnement du site, tandis que d\'autres nous aident à analyser l\'utilisation et à améliorer notre offre.',
    acceptAll: 'Tout accepter',
    requiredOnly: 'Uniquement les essentiels',
    details: 'Détails',
    saveSelection: 'Enregistrer la sélection',
    close: 'Fermer',
    alwaysActive: 'Toujours actif',
    requiredCategory: 'Essentiels',
    requiredDescription: 'Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés. Ils permettent des fonctions de base telles que la navigation et la protection anti-spam.',
    statisticsCategory: 'Statistiques / Marketing',
    statisticsDescription: 'Ces cookies nous aident à comprendre l\'utilisation de notre site et à améliorer notre offre. Ils permettent la collecte de données de visite anonymisées.',
    cookieName: 'Cookie',
    cookieProvider: 'Fournisseur',
    cookiePurpose: 'Objectif',
    cookieDuration: 'Durée',
    session: 'Session',
    minutes30: '30 minutes',
    hours24: '24 heures',
    days365: '1 an',
    years2: '2 ans',
    purposeSession: 'Gestion de session',
    purposeTurnstile: 'Protection anti-spam',
    purposeConsent: 'Enregistre les paramètres des cookies',
    purposeGa: 'Identification des visiteurs pour l\'analyse web',
    purposeGid: 'Identification temporaire des visiteurs',
    purposeHotjarUser: 'Identification des visiteurs pour les cartes thermiques',
    purposeHotjarSession: 'Suivi de session pour les cartes thermiques',
  },
};

const lang = (document.documentElement.lang || 'de').substring(0, 2);
const t = messages[lang] || messages.de;

const COOKIE_NAME = 'cookie_consent';
const COOKIE_VERSION = 1;
const COOKIE_DAYS = 365;

// Configuration is provided via window.cookieConsentConfig (set in Twig).
// Services are auto-detected based on which IDs are present.
const config = (typeof window !== 'undefined' && window.cookieConsentConfig) || {};
const GTM_ID = config.gtmId || '';
const HOTJAR_ID = config.hotjarId || '';
const HAS_GTM = !!GTM_ID;
const HAS_HOTJAR = !!HOTJAR_ID;
const HAS_STATISTICS = HAS_GTM || HAS_HOTJAR;

function readConsent() {
  const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
  if (!match) return null;
  try {
    const data = JSON.parse(decodeURIComponent(match[1]));
    if (data && data.version === COOKIE_VERSION) return data;
  } catch (e) { /* invalid cookie */ }
  return null;
}

function writeConsent(data) {
  const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  const value = encodeURIComponent(JSON.stringify({
    ...data,
    version: COOKIE_VERSION,
    timestamp: new Date().toISOString(),
  }));
  document.cookie = COOKIE_NAME + '=' + value + '; path=/; expires=' + expires + '; SameSite=Lax';
}

function loadGTM() {
  if (!HAS_GTM || window._gtmLoaded) return;
  window._gtmLoaded = true;
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_ID);
}

function loadHotjar() {
  if (!HAS_HOTJAR || window._hotjarLoaded) return;
  window._hotjarLoaded = true;
  (function(h, o, t, j, a, r) {
    h.hj = h.hj || function() { (h.hj.q = h.hj.q || []).push(arguments); };
    h._hjSettings = { hjid: HOTJAR_ID, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

const statisticsCookiesList = [
  ...(HAS_GTM ? [
    { name: '_ga', provider: 'Google', purpose: t.purposeGa, duration: t.years2 },
    { name: '_gid', provider: 'Google', purpose: t.purposeGid, duration: t.hours24 },
  ] : []),
  ...(HAS_HOTJAR ? [
    { name: '_hjSessionUser_*', provider: 'Hotjar', purpose: t.purposeHotjarUser, duration: t.days365 },
    { name: '_hjSession_*', provider: 'Hotjar', purpose: t.purposeHotjarSession, duration: t.minutes30 },
  ] : []),
];

export default () => ({
  showBanner: false,
  showModal: false,
  statistics: false,
  requiredOpen: false,
  statisticsOpen: false,
  t,
  hasGTM: HAS_GTM,
  hasHotjar: HAS_HOTJAR,
  hasStatistics: HAS_STATISTICS,

  init() {
    // No tracking services configured → no consent UI needed at all.
    if (!HAS_STATISTICS) {
      this.showBanner = false;
      return;
    }
    const consent = readConsent();
    if (consent) {
      this.statistics = !!consent.statistics;
      if (this.statistics) {
        loadGTM();
        loadHotjar();
      }
    } else {
      this.showBanner = true;
    }
  },

  acceptAll() {
    this.statistics = true;
    writeConsent({ statistics: true });
    this.showBanner = false;
    loadGTM();
    loadHotjar();
  },

  acceptRequired() {
    this.statistics = false;
    writeConsent({ statistics: false });
    this.showBanner = false;
  },

  openDetails() {
    this.showBanner = false;
    this.showModal = true;
  },

  openPreferences() {
    const consent = readConsent();
    if (consent) this.statistics = !!consent.statistics;
    this.showBanner = false;
    this.showModal = true;
  },

  saveSelection() {
    writeConsent({ statistics: this.statistics });
    this.showModal = false;
    if (this.statistics) {
      loadGTM();
      loadHotjar();
    }
  },

  closeModal() {
    this.showModal = false;
    const consent = readConsent();
    if (!consent) this.showBanner = true;
  },

  requiredCookies: [
    { name: 'CraftSessionId', provider: 'teppichhuber.ch', purpose: t.purposeSession, duration: t.session },
    { name: 'cf_clearance', provider: 'Cloudflare', purpose: t.purposeTurnstile, duration: t.minutes30 },
    { name: COOKIE_NAME, provider: 'teppichhuber.ch', purpose: t.purposeConsent, duration: t.days365 },
  ],

  statisticsCookies: statisticsCookiesList,
});
